// extracted by mini-css-extract-plugin
module.exports = {"value":"value__cn59b","docIcon":"docIcon__2pXYt"};